import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import RoleSelection from './pages/RoleSelection';
import TechnicianRegister from './pages/TechnicianRegister';
import HirerRegister from './pages/HirerRegister';
import SignIn from './pages/SignIn';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import About from './pages/About';
import Contact from './pages/Contact';
import TechnicianDashboard from './pages/TechnicianDashboard';
import TechnicianPending from './pages/TechnicianPending';
import TechnicianDenied from './pages/TechnicianDenied';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import HirerDashboard from './pages/HirerDashboard';
import TechnicianProfile from './pages/TechnicianProfile';
import Billing from './pages/Billing';
import PastHires from './pages/PastHires';
import Messages from './pages/Messages';
import SupportChat from './pages/SupportChat';

function AppRoutes() {
  const location = useLocation();
  const noHeaderPaths = [
    '/',
    '/select-role',
    '/technician/dashboard',
    '/technician/pending',
    '/technician/denied',
    '/technician/messages',
    '/technician/support',
    '/hirer/dashboard',
    '/hirer/messages',
    '/hirer/support',
    '/hirer/past-hires',
    '/admin',
    '/admin/dashboard',
  ];
  const noHeaderPrefixes = ['/hirer/technician/'];
  const showHeader = !noHeaderPaths.includes(location.pathname)
    && !noHeaderPrefixes.some((prefix) => location.pathname.startsWith(prefix));

  return (
    <div className="App">
      {showHeader && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/select-role" element={<RoleSelection />} />
        <Route path="/technician/register" element={<TechnicianRegister />} />
        <Route path="/hirer/register" element={<HirerRegister />} />
        {/* <Route path="/hirer/login" element={<HirerLoginPlaceholder />} /> */}
        <Route path="/technician/signin" element={<SignIn />} />
        <Route path="/hirer/signin" element={<SignIn />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/technician/pending" element={<TechnicianPending />} />
        <Route path="/technician/denied" element={<TechnicianDenied />} />
        <Route
          path="/technician/dashboard"
          element={
            <ProtectedRoute requiredRole="technician" requiredStatus="approved">
              <TechnicianDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/hirer/dashboard"
          element={
            <ProtectedRoute requiredRole="hirer">
              <HirerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/hirer/messages"
          element={
            <ProtectedRoute requiredRole="hirer">
              <Messages />
            </ProtectedRoute>
          }
        />
        <Route
          path="/technician/messages"
          element={
            <ProtectedRoute requiredRole="technician">
              <Messages />
            </ProtectedRoute>
          }
        />
        <Route
          path="/hirer/support"
          element={
            <ProtectedRoute requiredRole="hirer">
              <SupportChat />
            </ProtectedRoute>
          }
        />
        <Route
          path="/technician/support"
          element={
            <ProtectedRoute requiredRole="technician">
              <SupportChat />
            </ProtectedRoute>
          }
        />
        <Route
          path="/hirer/past-hires"
          element={
            <ProtectedRoute requiredRole="hirer">
              <PastHires />
            </ProtectedRoute>
          }
        />
        <Route
          path="/hirer/technician/:id"
          element={
            <ProtectedRoute requiredRole="hirer">
              <TechnicianProfile />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router basename="/technician">
      <AppRoutes />
    </Router>
  );
}

export default App;